import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  UploadFile,
  UploadProps,
  message,
} from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import "react-quill/dist/quill.snow.css";
import { useHistory, useParams } from "react-router";
import { useEffectOnce } from "react-use";
import CategorySelectTreeComponent from "../../../Layout/CategorySelectTree";
import Tinymce from "../../../Layout/TyniMce";
import UploadImgComponent from "../../../Layout/uploadImg";
import { useAppSelector } from "../../../app/hooks";
import { PostInterface } from "../../../models/post";
import { isCheckPermisson } from "../../../utils";
import { FileTypeEnum } from "../../../utils/enum";
import { PERMISSION_ENUM } from "../../../utils/permisson.enum";
import PostHistoryPage from "../../postHistory/component";
import { IUserState } from "../../user/propState";
import "./quill.scss";
import {
  uploadFile,
  deleteFileIncludeFilePath,
} from "../../../Layout/file/services";
import { get } from "lodash";
import UploadFileComponent from "../../../Layout/uploadFile";
import { getCategoriesTree } from "../../category/services";
import { ICategory } from "../../category/category.model";
const { TextArea } = Input;
const RECRUITMENT_LOCATIONS = ["An Khánh", "Hòa Lạc", "Tùng Thiện"];
const RECRUITMENT_INDUSTRIES = [
  "Kinh doanh",
  "Đầu tư mua sắm",
  "Chuyên viên đào tạo",
  "CNTT - Phần mềm",
  "CNTT/ Phần cứng/ Mạng",
  "Sản xuất",
  "Nghiên cứu phát triển",
  "Hành chính",
  "Tài chính Kế toán",
  "Nhân sự",
  "Marketing/PR/Truyền thông",
];

const formatVnd = (value?: string | number | null) => {
  if (value === null || value === undefined || value === "") return "";
  const numberValue = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(numberValue)) return "";
  return `${numberValue.toLocaleString("vi-VN")} VNĐ`;
};

const parseVnd = (value?: string) => {
  if (!value) return "";
  return value.replace(/[^\d]/g, "");
};

const PostComponent = (props: any) => {
  const MAX_FILE_SIZE: number = 200 * 1024 * 1024;
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const allowedFileTypes = [".zip", ".rar", ".rar4"];
  const param = new URLSearchParams(props.location.search);
  const slug = param.get("slug") || "";
  const history = useHistory();
  const [form] = Form.useForm();
  form.setFieldsValue(props.postInit);
  const [post, setPost] = useState<PostInterface>(props.postInit);
  const [slugPost] = useState<string>(slug);
  const [isHistory, setIsHistory] = useState<boolean>(false);
  const [recruitmentCategoryIds, setRecruitmentCategoryIds] = useState<Set<string>>(
    new Set()
  );
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | undefined>(
    props.postInit.category
  );
  const { id }: any = useParams();

  const goBack = () => {
    history.goBack();
  };

  const userState = useAppSelector<IUserState>((state) => state.screens.user);
  const permissionObj = userState.permissionObj;
  const isPostPublish = isCheckPermisson(
    permissionObj,
    PERMISSION_ENUM.POST_ISPUBLISH
  );

  const _onFinish = async () => {
    props.onSubmit(props.postList);
    // _onSubmitCourse();
  };
  useEffectOnce(() => {
    const loadRecruitmentTree = async () => {
      const response: any = await getCategoriesTree({});
      const categories: ICategory[] = get(response, "data", []);

      const root = categories.find((cate) => {
        const slugValue = (cate.slug || "").toLowerCase();
        const titleValue = (cate.title || "").toLowerCase();
        return (
          slugValue.includes("recruiment") ||
          slugValue.includes("recruitment") ||
          titleValue.includes("tuyển dụng") ||
          titleValue.includes("tuyen dung")
        );
      });

      if (!root?.id) return;
      const idSet = new Set<string>();
      const collectIds = (node: ICategory) => {
        if (node.id) idSet.add(node.id);
        (node.children || []).forEach((child) => collectIds(child));
      };
      collectIds(root);
      setRecruitmentCategoryIds(idSet);
    };

    loadRecruitmentTree();
    setPost({ ...post, ...props.postInit });
    props.postInit.fileId !== 0 &&
      setFileList([
        {
          uid: props.postInit.fileId,
          name: props.postInit.file,
        },
      ]);
  });
  const isRecruitmentCategorySelected = !!(
    selectedCategoryId && recruitmentCategoryIds.has(String(selectedCategoryId))
  );
  const currentPost = props.postList?.[props.index] || props.postInit;

  const recruitmentDeadlineDayjs = (() => {
    const raw = currentPost?.recruitmentDeadline;
    if (raw == null || raw === "") return undefined;
    const d = dayjs(raw as string | number | Date);
    return d.isValid() ? d : undefined;
  })();

  const onChangeHtml = (html: string) => {
    props.onChange(props.postList, html, "contentHtmlCoppy", props.index);
  };
  const onChangeFile = (
    fileId: number | undefined,
    file: string | undefined
  ) => {
    if (typeof fileId === "number" && typeof file === "string") {
      props.onChange(props.postList, fileId, "fileId", props.index);
      props.onChange(props.postList, file, "file", props.index);
    } else if (fileId === undefined && file === undefined) {
      props.onChange(props.postList, 0, "fileId", props.index);
      props.onChange(props.postList, " ", "file", props.index);
    }
  };
  const uploaFileProps: UploadProps = {
    onChange: async (info) => {
      if (info.file.status !== "removed") {
        let fileSize: number = 0;
        if (info.file && info.file.size !== undefined) {
          fileSize = info.file.size; // Gán giá trị khi điều kiện đúng
          if (fileSize > MAX_FILE_SIZE) {
            message.error(
              "Dung lượng file tối đa " + MAX_FILE_SIZE / 1024 / 1024 + " MB"
            );
          } else {
            const data = await uploadFile({
              file: info.file,
              name: info.file.name,
              minType: info.file.type,
              type: FileTypeEnum.PRODUCT,
            });
            if (data) {
              const fileId = get(data, "data.id");
              const file = get(data, "data.name");
              if (fileId && fileId !== undefined) {
                info.file.uid = fileId;
              }
              form.setFieldValue("fileId", fileId);
              onChangeFile(fileId, file);
            }
            setFileList([info.file]);
          }
        } else {
          message.error("File size information is missing.");
        }
      } else if (info.file.status === "removed") {
        let fileIdBefore: number = parseInt(info.file.uid);
        if (fileIdBefore && fileIdBefore !== undefined) {
          const data = await deleteFileIncludeFilePath(fileIdBefore);
          const fileIdAfter = undefined;
          const fileAfter = undefined;
          form.setFieldsValue({ fileIdAfter });
          onChangeFile(fileIdAfter, fileAfter);
          setFileList([]);
        }
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    accept: ".zip, .rar, .rar4",
    fileList,
  };

  return (
    <>
      <Card>
        <Form
          className="form-create-currency row"
          form={form}
          layout="vertical"
          onFinish={_onFinish}
        >
          <Row gutter={10} className="m-0">
            <Col xl={8}>
              <Form.Item
                name="name"
                label={
                  slugPost === "/product" ? "Tên sản phẩm" : "Tên bài viết"
                }
                rules={[
                  {
                    required: true,
                    message: `Vui lòng nhập ${
                      slugPost === "/product" ? "tên sản phẩm" : "tên bài viết"
                    } `,
                  },
                ]}
              >
                <Input
                  value={props.postInit.name}
                  name={props.postInit.name}
                  onChange={(e) =>
                    props.onChange(
                      props.postList,
                      e.target.value,
                      "name",
                      props.index
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col xl={8}>
              <Form.Item
                name="title"
                label={
                  slugPost === "/product"
                    ? "Tiêu đề sản phẩm"
                    : "Tiêu đề bài viết"
                }
                rules={[
                  {
                    required: true,
                    message: `Vui lòng nhập ${
                      slugPost === "/product"
                        ? "tiêu đề sản phẩm"
                        : "tiêu đề bài viết"
                    }`,
                  },
                ]}
              >
                <Input
                  value={props.postInit.title}
                  name={props.postInit.title}
                  onChange={(e) =>
                    props.onChange(
                      props.postList,
                      e.target.value,
                      "title",
                      props.index
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col xl={4}>
              <Form.Item name="isPublish" label="Danh mục">
                <CategorySelectTreeComponent
                  categoryId={props.postInit.category}
                  filter={{ slug }}
                  onSelect={(value) => {
                    setSelectedCategoryId(value);
                    props.onCommon(props.postList, value, "category");
                  }}
                  languagesOther={
                    slug !== "/product"
                      ? [
                          {
                            title: "Danh mục gốc",
                            value: "null",
                          },
                        ]
                      : []
                  }
                  onClear={() => {
                    setSelectedCategoryId(undefined);
                    props.onCommon(props.postList, undefined, "category");
                  }}
                />
              </Form.Item>
            </Col>
            <Col xl={2}>
              <Form.Item
                className="post-isPubish text-center"
                name="isPublish"
                label="Xuất&nbsp;bản"
                // className="text-center"
              >
                <Switch
                  className="bg-gray-600"
                  checked={props.postInit.isPublish}
                  disabled={!isPostPublish}
                  onChange={() =>
                    props.onCommon(
                      props.postList,
                      !props.postInit.isPublish,
                      "isPublish"
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col xl={2}>
              <Form.Item name="indexSort" label="Sắp xếp">
                <Input
                  value={props.postInit.indexSort}
                  name={props.postInit.indexSort}
                  onChange={(e) =>
                    props.onCommon(props.postList, e.target.value, "indexSort")
                  }
                />
              </Form.Item>
            </Col>
            <Col xl={8} className="flex">
              <Form.Item name="icon" label="Ảnh bìa">
                <UploadImgComponent
                  className="post-upload"
                  keyPath={"icon"}
                  setImg={(icon) =>
                    props.onCommon(props.postList, icon, "icon")
                  }
                  url={props.postInit.icon}
                  type={FileTypeEnum.POST}
                />
              </Form.Item>
              <Form.Item
                name="icon"
                label="Liên kết ảnh bìa"
                className="w-full"
              >
                <Input
                  className="break-words break-all"
                  style={{
                    minHeight: "102px",
                  }}
                  value={props.postInit.icon}
                  onChange={(e) =>
                    props.onCommon(props.postList, e.target.value, "icon")
                  }
                />
              </Form.Item>
            </Col>
            <Col xl={16}>
              <Form.Item name="content" label="Mô tả" className="w-full">
                <TextArea
                  style={{
                    minHeight: "102px",
                  }}
                  className="h-24 important min-h-full w-full"
                  value={props.postInit.content}
                  name={props.postInit.content}
                  onChange={(e) =>
                    props.onChange(
                      props.postList,
                      e.target.value,
                      "content",
                      props.index
                    )
                  }
                />
              </Form.Item>
            </Col>
            {slugPost !== "/product" && isRecruitmentCategorySelected && (
              <>
                <Col xl={24}>
                  <h4>Thông tin tuyển dụng (tùy chọn)</h4>
                </Col>
                <Col xl={6}>
                  <Form.Item name="recruitmentQuantity" label="Số lượng cần tuyển">
                    <Input
                      type="number"
                      min={0}
                      value={props.postInit.recruitmentQuantity}
                      onChange={(e) =>
                        props.onChange(
                          props.postList,
                          e.target.value ? Number(e.target.value) : undefined,
                          "recruitmentQuantity",
                          props.index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  <Form.Item name="recruitmentSalaryMin" label="Mức lương từ">
                    <InputNumber
                      className="w-full"
                      min={0}
                      step={100000}
                      formatter={formatVnd}
                      parser={parseVnd as any}
                      value={props.postInit.recruitmentSalaryMin}
                      onChange={(value) =>
                        props.onChange(
                          props.postList,
                          typeof value === "number" ? value : undefined,
                          "recruitmentSalaryMin",
                          props.index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  <Form.Item name="recruitmentSalaryMax" label="Mức lương đến">
                    <InputNumber
                      className="w-full"
                      min={0}
                      step={100000}
                      formatter={formatVnd}
                      parser={parseVnd as any}
                      value={props.postInit.recruitmentSalaryMax}
                      onChange={(value) =>
                        props.onChange(
                          props.postList,
                          typeof value === "number" ? value : undefined,
                          "recruitmentSalaryMax",
                          props.index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  {/* Bỏ name: Form không inject string vào DatePicker (antd 5 cần dayjs) */}
                  <Form.Item label="Thời hạn ứng tuyển">
                    <DatePicker
                      className="w-full"
                      format="DD/MM/YYYY"
                      value={recruitmentDeadlineDayjs}
                      onChange={(value) =>
                        props.onChange(
                          props.postList,
                          value ? value.toISOString() : undefined,
                          "recruitmentDeadline",
                          props.index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xl={12}>
                  <Form.Item name="recruitmentLocation" label="Địa điểm">
                    <Select
                      value={currentPost?.recruitmentLocation}
                      placeholder="Chọn địa điểm"
                      options={RECRUITMENT_LOCATIONS.map((location) => ({
                        label: location,
                        value: location,
                      }))}
                      onChange={(value) =>
                        props.onChange(
                          props.postList,
                          value,
                          "recruitmentLocation",
                          props.index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xl={12}>
                  <Form.Item name="recruitmentIndustry" label="Ngành nghề">
                    <Select
                      value={currentPost?.recruitmentIndustry}
                      placeholder="Chọn ngành nghề"
                      options={RECRUITMENT_INDUSTRIES.map((industry) => ({
                        label: industry,
                        value: industry,
                      }))}
                      onChange={(value) =>
                        props.onChange(
                          props.postList,
                          value,
                          "recruitmentIndustry",
                          props.index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
              </>
            )} 
            <Col xl={24}>
              <Form.Item name="fileId" label="Upload tài liệu">
                <UploadFileComponent
                  title="Tải lên file"
                  propsFile={uploaFileProps}
                />
                <div style={{ fontSize: "10px", color: "red" }}>
                  *Chỉ chấp nhận các định dạng file{allowedFileTypes.join(",")}{" "}
                </div>
              </Form.Item>
            </Col>
            <Col xl={24}>
              <Tinymce
                initialValue={props.postInit.contentHtml}
                onChangeHtml={onChangeHtml}
              />
            </Col>
            <Divider className="mt-0" />
            <Col xl={24}>
              <Button type="primary" ghost htmlType="submit">
                {id ? "Cập nhật" : "Thêm mới"}
              </Button>
              <Button onClick={goBack} danger className="ml-3">
                Hủy
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
      {id && (
        <Card
          className="mt-3"
          title="Lịch sử chỉnh sửa"
          extra={
            !isHistory ? (
              <EyeOutlined
                className=" text-green-600 text-xl cursor-pointer"
                onClick={() => setIsHistory(!isHistory)}
              />
            ) : (
              <EyeInvisibleOutlined
                color="#ff4b2b"
                className="text-red-600 text-xl cursor-pointer"
                onClick={() => setIsHistory(!isHistory)}
              />
            )
          }
        >
          {isHistory && <PostHistoryPage postId={id} />}
        </Card>
      )}
    </>
  );
};

export default PostComponent;
